<template>
	<div class="destroy-page">
		<div class="box">
			<div v-if="!isDestroy">
				<div class="title">注销账号</div>
				<div class="line-box">
					<div class="line">注销账号是不可恢复的操作，请您确认：</div>
					<div class="line">
						1、注销后，您将无法登录、使用本账号。
					</div>
					<div class="line">
						2、您的<span class="danger"
							>以下信息将被清空且无法找回</span
						>：身份信息、账号信息、所有使用记录，包括不限于项目信息、负载数据、测算参数配置、测算报告等。
					</div>
					<div class="line">
						3、您的<span class="danger">分享链接</span
						>将全部失效，他人无法查看您曾生成的任何测算报告。
					</div>
				</div>

				<div class="confirm">
					<div class="line">
						点击下方“确定注销”按钮，即代表您已阅读并同意以上内容。
					</div>
					<div class="btns">
						<a-button @click="cancle">取消</a-button>
						<a-button
							type="primary"
							danger
							style="margin-left: 16px"
							@click="destroyClick"
							>确定注销</a-button
						>
					</div>
				</div>
			</div>

			<a-result
				v-else
				status="success"
				title="您的账户已成功注销!"
				sub-title="您将在5秒内返回登录页，轻舟期待与您再次相遇"
				style="result"
			>
			</a-result>
		</div>
	</div>
</template>

<script setup>
	import { ref } from "vue";
	import { useRouter } from "vue-router";
	const router = useRouter();

	const isDestroy = ref(false);

    const cancle = ()=>{
        router.go(-1)
    }

	const destroyClick = () => {
		isDestroy.value = true;

		// setTimeout(() => {
		// 	router.push("/");
		// }, 5000);
	};
</script>

<style lang="less" scoped>
	.destroy-page {
		width: 100%;
		height: calc(100vh - 88px);
		padding: 24px 0 76px 0;
		position: relative;

		.box {
			height: 100%;
			background: #ffffff;
			border: 1px solid #dbe0e8;
			border-radius: 4px;
			padding: 26px 32px;
			position: relative;

			.title {
				font-size: 18px;
				font-weight: bold;
				margin-bottom: 32px;
			}

			.line-box {
				margin-top: 16px;
				.line {
					line-height: 32px;
				}

				.danger {
					color: red;
				}
			}

			.confirm {
				margin-top: 168px;

				.btns {
					position: absolute;
					left: 50%;
					transform: translateX(-50%);
					margin-top: 32px;
				}
			}
		}
	}

	::v-deep .ant-result {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		padding: 0;
	}
</style>
